import { gate } from 'hub-http/gates';
export const GROWTH_PLAN_REMOVAL_GATE = gate('GrowthCoaching:RemoveGPCode');